import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import GearActivationMethodService from "@services/GearActivationMethodService";

const ShowGearActivationMethod = ({ gearActivationMethod }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [gearActivationMethodData, setGearActivationMethodData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      GearActivationMethodService.find(gearActivationMethod.id).then(
        (response) => {
          setGearActivationMethodData(response.data.data);
        }
      );
  }, [gearActivationMethod.id, showModal]);

  return (
    <PermissionHandler permission={"view_gear_activation_methods"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={gearActivationMethodData.name} />
          <RowDetails
            label={t("nameEng")}
            value={gearActivationMethodData.name_eng}
          />
          <RowDetails
            label={t("description")}
            value={gearActivationMethodData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowGearActivationMethod;
